<div class="container-fluid">
    <div class="row">

        <div class="card shadow-sm p-0">
            <div class="card-header">
                <h3 class="card-title">{{ employeeSpecialisationId ? 'Update Specialisation' : 'Specialisation User' }} </h3>
            </div>
            <div class="card-body">
                <specialisation-form [employeeSpecialisation]="employeeSpecialisation" />
            </div>
        </div>
    </div>

</div>